import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IInvoiceParams, IInvoiceResponse, IInvoiceState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchUpdateInvoice = createAsyncThunk(
  'listInvoices/fetchUpdateInvoice',
  async ({ id, params }: { id: string; params: IInvoiceParams }, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.updateInvoice(id, params)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IInvoiceState = {
  isLoading: false,
  response: null,
  error: null
}

const updateInvoiceSlice = createSlice({
  name: 'states/update',
  initialState,
  reducers: {
    resetUpdateInvoice: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchUpdateInvoice.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchUpdateInvoice.fulfilled, (state, action: PayloadAction<IInvoiceResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchUpdateInvoice.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default updateInvoiceSlice.reducer
export const { resetUpdateInvoice } = updateInvoiceSlice.actions
